import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { NzDrawerRef } from "ng-zorro-antd/drawer";
import { NzModalService } from "ng-zorro-antd/modal";
import { filter } from "rxjs";

@Component({
  selector: "host-bs-listings-detail",
  templateUrl: "./bs-listings-detail.component.html",
  styleUrls: ["./bs-listings-detail.component.scss"],
})
export class BsListingsDetailComponent implements OnInit {
  @Input({ required: true }) listingId;
  @Input({ required: true }) thirdpartyAccountId;
  @Input() type: "self_hosted" | "hostex" = "hostex";
  @Output() onUpdated = new EventEmitter();
  detail;

  priceInfo;

  widgetUrl;

  loading = false;

  constructor(
    private drawerRef: NzDrawerRef,
    private router: Router,
    private modal: NzModalService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());

    this.loading = true;
    this.fetchListingDetail();
  }

  fetchListingDetail() {
    const params = {
      thirdparty_account_id: this.thirdpartyAccountId,
      listing_id: this.listingId,
    };
    this.http.get("/api/bs/listings/detail", { params }).subscribe((rst: any) => {
      this.loading = false;
      this.detail = rst?.data;
      this.priceInfo = {
        weekend_price: this.detail?.weekend_price,
        base_price: this.detail?.base_price,
      };

      this.widgetUrl = `${this.detail.widget_host}/widget/check?host_id=${this.detail.host_id}&listing_id=${this.listingId}&enabled=${this.detail.is_listed}`;
    });
  }

  private requestDeleteListing() {
    const params = {
      thirdparty_account_id: this.thirdpartyAccountId,
      listing_id: this.listingId,
    };
    this.http.post("/api/bs/listings/delete", params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.drawerRef.close();
      }
    });
  }

  onDeleteListing() {
    this.modal.confirm({
      nzTitle: "Are you sure you want to delete this listing?",
      nzOkText: "Yes",
      nzOnOk: () => this.requestDeleteListing(),
    });
  }

  onClose() {
    this.drawerRef.close();
  }
}
